<template>
    <div class="gray-back" style="padding:.2rem 0 8rem 0 ; height:auto !important">

            <van-divider class="start-head-divider" @click="openConfig">
              {{saiqu.name}} {{start.title}}
              <van-icon name="setting-o" class="start-head-setting-icon" />
            </van-divider>
      <van-cell-group>
                <van-cell :key="index" v-for="(row,index) in list" :title="'#'+(index+1)+' '+row.mingcheng" @click="selectShow(row)"  is-link=""> 
                    <template slot="label">
                      <span class="font-size0 van-color-text-assist"> {{row.subject_name}}</span>
                      <div v-if="row.jianlu_note" class="jianlu-note-line">{{ row.jianlu_note }}</div> 
                    </template>
                    <template>
                    <span style="color:#999" v-if="row.jianlu_status==0" >待检录</span> 
                     <span style="color:#1989fa"  v-else-if="row.jianlu_status==1" >检录1</span> 
                   <span style="color:#1989fa"  v-else-if="row.jianlu_status==2">检录2</span> 
                    <!-- <span style="color:#1989fa"  v-else-if="row.jianlu_status==3">检录3</span>  -->
                    <span style="color:#1989fa"  v-else-if="row.jianlu_status==4">已签到</span> 
                    <span style="color:#32ae57"  v-else-if="row.jianlu_status==5">检录完成</span> 
                    <span style="color:#000"  v-else-if="row.jianlu_status==7">比赛完成</span> 
                    <span style="color:#c39004"  v-else-if="row.jianlu_status==8">弃权</span> 
                    <span style="color:#f00"  v-else-if="row.jianlu_status==9">超时未到</span>
                  </template>
                </van-cell> 
      </van-cell-group>

      <van-action-sheet v-model="optionsShow" :actions="actions" @select="onSelect" />

      <van-dialog
        v-model="jianluNoteShow"
        title="备注原因"
        show-cancel-button
        confirm-button-text="提交"
        :before-close="onJianluNoteBeforeClose"
      >
        <div class="jianlu-note-dialog-body">
          <van-field
            v-model="jianluNoteInput"
            type="textarea"
            rows="4"
            maxlength="500"
            placeholder="请输入问题内容"
            show-word-limit
          />
        </div>
      </van-dialog>

      <van-popup
        v-model="configShow"
        position="bottom"
        round
        :style="{ maxHeight: '85%' }"
        closeable
        close-icon-position="top-right"
        @close="onConfigClosed"
      >
        <div class="jianlu-config-popup">
          <div class="jianlu-config-title">场次配置</div>
          <van-cell title="时间调整" />
          <van-radio-group v-model="configForm.delayDirection" direction="horizontal" class="jianlu-config-radio">
            <van-radio name="delay">延误</van-radio>
            <van-radio name="early">提前</van-radio>
          </van-radio-group>
          <van-field
            v-model="configForm.delayMinutes"
            type="digit"
            label="分钟"
            placeholder="请输入分钟数"
            input-align="right"
          />
          <!-- <van-cell title="检录大屏显示" />
          <van-radio-group v-model="configForm.jianluShowType" class="jianlu-config-radio jianlu-config-radio--block">
            <van-radio :name="1">检录列表</van-radio>
            <van-radio :name="2">直播画面</van-radio>
          </van-radio-group> -->
          <div class="jianlu-config-actions">
            <van-button type="primary" block :loading="configSaving" @click="saveConfig">
              保存
            </van-button>
          </div>
        </div>
      </van-popup>

  </div>
</template>

<script>
import { Toast, ActionSheet, Dialog, Field, Popup, Radio, RadioGroup, Button, Icon } from "vant";
export default {
  name: "StartList",
  data: function () {
    return {
      optionsShow: false,
      selectId: 0,
      jianluNoteShow: false,
      jianluNoteInput: "",
      configShow: false,
      configSaving: false,
      configForm: {
        delayDirection: "delay",
        delayMinutes: "0",
        jianluShowType: 1,
      },
      actions: [
        { name: '待检录', status: 0 },
        { name: '检录1', status: 1 },
        { name: '检录2', status: 2 },
        // { name: '检录3', status: 3 },
        // { name: '已签到', subname: '', status: 4 },
        { name: '检录完成', subname: '', status: 5 },
        // { name: '播报入场', subname: '', kind: 'broadcast' },
        { name: '播报催场', subname: '', kind: 'broadcast' },

        { name: '比赛完成', subname: '', status: 7 },
        { name: '弃权', subname: '', status: 8 },
        { name: '备注原因', subname: '', kind: 'note' },
        // { name: '超时未到', subname: '', status: 9 },
      ],
        start: { 
        },
        saiqu:{},
        list: [], 
    }
  },
  components: {
    ActionSheet,
    Dialog,
    Field,
    Popup,
    Radio,
    RadioGroup,
    Button,
    Icon,
  },
  filters: {},
  mounted() {
    let that = this;
    document.title="检录信息"
    that.fetch()
    // 换成轮询
    that.timer = setInterval(function () {
      that.fetch()
    }, 2000)
  },
  destroyed() {
    // 销毁监听
    // this.socket.close()
    clearInterval(this.timer)
  },
  methods: {
    syncConfigFormFromStart() {
      const delayTime = Number(this.start && this.start.delay_time) || 0
      if (delayTime < 0) {
        this.configForm.delayDirection = "early"
        this.configForm.delayMinutes = String(Math.abs(delayTime))
      } else {
        this.configForm.delayDirection = "delay"
        this.configForm.delayMinutes = String(delayTime)
      }
      const showType = Number(this.start && this.start.jianlu_show_type) || 1
      this.configForm.jianluShowType = showType === 2 ? 2 : 1
    },
    openConfig() {
      this.syncConfigFormFromStart()
      this.configShow = true
      this.pausePoll()
    },
    onConfigClosed() {
      this.resumePoll()
    },
    pausePoll() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    resumePoll() {
      if (this.timer) {
        return
      }
      const that = this
      that.timer = setInterval(function () {
        that.fetch()
      }, 2000)
    },
    saveConfig() {
      const minutes = parseInt(this.configForm.delayMinutes, 10)
      if (isNaN(minutes) || minutes < 0) {
        Toast("请填写有效的分钟数")
        return
      }
      let delayTime = minutes
      if (this.configForm.delayDirection === "early") {
        delayTime = -minutes
      }
      const startId = Number(this.$route.query.start_id) || 0
      if (!startId) {
        Toast("缺少场次信息")
        return
      }
      this.configSaving = true
      const that = this
      that.$api.post(
        "/api/dscore/saveJianluStartConfig",
        {
          start_id: startId,
          delay_time: delayTime,
          jianlu_show_type: that.configForm.jianluShowType,
        },
        (res) => {
          that.configSaving = false
          if (res.data && res.data.start) {
            that.start = res.data.start
          }
          that.configShow = false
          Toast.success("已保存")
          that.resumePoll()
          that.fetch()
        },
        (res) => {
          that.configSaving = false
          Toast(res.msg || "保存失败")
        }
      )
    },
    selectShow(row){
      this.optionsShow=true;
      this.selectId = row.id
    },
    onSelect(action) {
      if (action && action.kind === 'broadcast') {
        this.optionsShow = false
        const row = this.list.find((r) => r.id === this.selectId)
        if (!row || !(String(row.danwei || '').trim())) {
          Toast('单位名称为空，无法播报')
          return
        }
        this.$api.post(
          '/api/dscore/jianluBroadcastEntrance',
          { id: this.selectId },
          () => {
            Toast.success('已推送入场播报')
          },
          (res) => {
            Toast(res.msg || '播报失败')
          }
        )
        return
      }
      if (action && action.kind === 'note') {
        this.optionsShow = false
        const row = this.list.find((r) => r.id === this.selectId)
        this.jianluNoteInput =
          row && row.jianlu_note ? String(row.jianlu_note) : ""
        this.jianluNoteShow = true
        return
      }
      const status = action && action.status
      if (status === undefined) {
        return
      }
      this.submitSetJianlu(status, "")
    },
    onJianluNoteBeforeClose(action, done) {
      if (action === "confirm") {
        const note = (this.jianluNoteInput || "").trim()
        if (!note) {
          // Toast("请填写问题内容")
          // done(false)
          // return
        }
        const that = this
        that.$api.post(
          "/api/dscore/setjianlu",
          {
            id: that.selectId,
            jianlu_note: note,
            status:0,
            note_only: true,
          },
          () => {
            that.jianluNoteInput = ""
            done()
            that.fetch()
          },
          (res) => {
            Toast(res.msg)
            done(false)
          }
        )
      } else {
        this.jianluNoteInput = ""
        done()
      }
    },
    submitSetJianlu(status, jianlu_note) {
      const that = this
      that.$api.post(
        "/api/dscore/setjianlu",
        {
          status,
          id: that.selectId,
          jianlu_note: jianlu_note || "",
        },
        () => {
          that.optionsShow = false
          that.fetch()
        },
        (res) => {
          Toast(res.msg)
        }
      )
    },
    fetch() {
      let that = this;
      that.$api.post('/api/dscore/scoreStartJianluSubjectList', { 
        start_id: that.$route.query.start_id,
      }, (res) => {
        that.list = res.data.list;
        that.saiqu = res.data.saiqu;
        // 配置弹层打开时不更新 start，避免与表单本地编辑状态冲突
        if (!that.configShow) {
          that.start = res.data.start;
        }
      }, (res) => {
        Toast(res.msg) 
      })
    },
  }
}
</script>

<style scoped>
.start-head-divider {
  cursor: pointer;
  user-select: none;
}
.start-head-setting-icon {
  margin-left: 6px;
  font-size: 16px;
  vertical-align: middle;
  color: #969799;
}
.jianlu-config-popup {
  padding: 16px 16px 24px;
}
.jianlu-config-title {
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  margin-bottom: 12px;
}
.jianlu-config-radio {
  padding: 8px 16px 12px;
}
.jianlu-config-radio--block .van-radio {
  margin-bottom: 10px;
}
.jianlu-config-actions {
  margin-top: 16px;
  padding: 0 8px;
}
.jianlu-note-line {
  margin-top: 4px;
  font-size: 12px;
  color: #ee0a24;
  line-height: 1.4;
  word-break: break-all;
}
.jianlu-note-dialog-body {
  padding: 12px 16px 8px;
}
</style>



// WEBPACK FOOTER //
// StartList.vue?3b523bfc